const urls = {
    privacyPolicyURL: 'https://www.hcaptcha.com/privacy',
    termsOfServiceURL: 'https://www.hcaptcha.com/terms'
};

export default urls;
